import React, { createContext, useCallback, useEffect, useState } from 'react'
import {
    useLocation,

    // useNavigate
} from 'react-router-dom'
//@ts-ignore
import { useHistory } from 'react-router-dom'
import { matchPath } from 'react-router'
import isEqual from 'lodash.isequal'
import { TabProviderProps, TabstripColors } from './Tabstrip.types'
import merge from 'lodash/merge'

export interface ITabContext {
    current: string | number
    withRoute: boolean
    setCurrent: (id) => any
    registerTab: (tab) => void
    onTabSelect: (tab) => void
    getTab: (tab) => any
    getTabPath?: (id) => string | number
    colors?: TabstripColors
    initial?: string
}

export const TabContext = createContext<ITabContext>(undefined!)

const TabProvider = (props) => {
    const location = useLocation()
    // const nav = useNavigate()
    let history = useHistory()
    const [state, setState] = useState({
        loaded: false,
        initialSet: false,
        tabs: [],
        current: props.initial || null,
    })
    const [registeredTabs, setRegisteredTabs] = useState([])
    const [isMounted, setIsMounted] = useState(false)

    const setInitial = () => {
        let initialTab
        const tabs = registeredTabs
        if (tabs.length === 0) {
            return
        }

        tabs.forEach((tab) => {
            if (tab.initial) {
                initialTab = tab
            } else if (tab.path) {
                const match = matchPath(tab.path, location.pathname)
                if (match) {
                    initialTab = tab
                }
            }
        })

        if (!initialTab) {
            initialTab = tabs[0]
        }
        setCurrent(initialTab.id, true)
    }

    const onLocationChange = () => {
        const { tabs } = state
        if (tabs.length === 0) {
            return
        }
        const matchedTab = tabs.filter((tab) => {
            return matchPath(tab.path, location.pathname)
        })
        if (matchedTab.length === 0) {
            return
        }
        setCurrent(matchedTab[0].id)
    }

    const handleOnTabSelected = () => {
        if (props.onTabSelected) {
            props.onTabSelected(state.current)
        }
    }

    // componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    //     if (!isEqual(prevState.tabs, this.state.tabs)) {
    //         // if (JSON.stringify(prevState.tabs) !== JSON.stringify(flatten(this.state.tabs))) {
    //         // this.setInitial()
    //     }
    //     if (this.props.location !== prevProps.location) {
    //         this.onLocationChange()
    //     }
    //     if (this.state.current !== prevState.current) {
    //         this.handleOnTabSelected()
    //     }
    // }

    useEffect(() => {
        setTimeout(() => {
            setInitial()
        }, 100)
    }, [registeredTabs])

    useEffect(() => {
        onLocationChange()
    }, [location])

    useEffect(() => {
        if (isMounted) {
            handleOnTabSelected()
        }
    }, [state.current])

    useEffect(() => {
        if (state.initialSet) {
            setIsMounted(true)
        }
    }, [state])

    const setCurrent = (current, isInitial = false) => {
        setState((prev) => {
            const newState = merge({}, prev)
            newState.current = current

            if (isInitial) {
                newState.initialSet = true
            }

            return newState
        })
    }

    const registerTab = (tab) => {
        setState((prev) => {
            const newState = merge({}, prev)
            const tabs = prev.tabs.slice()
            tabs.push(tab)
            newState.tabs = tabs
            return newState
        })
        setRegisteredTabs((prev) => {
            const tabs = prev.slice()
            tabs.push(tab)
            return tabs
        })
    }

    const getTabPath = (id) => {
        if (!props.withRoute) {
            throw Error("This tab provider is not using routes, please add prop 'withRoute'")
        }
        let _path

        state.tabs.forEach((tab) => {
            if (tab.id === id) {
                if (!tab.path) {
                    throw Error('Tab: ' + tab.id + ' does not have a supplied path prop')
                }
                _path = tab.path
            }
        })

        return _path
    }

    const getTab = (id) => {
        const tab = state.tabs.slice().find((t) => t.id === id)

        if (tab) {
            return tab
        }
        // throw Error('Tab with id ' + id + ' could not be found, Tabs:' + JSON.stringify(tabs))
    }

    const selectTab = (tab) => {
        if (props.withRoute) {
            if (tab.path) {
                // nav(tab.path)
                history.push(tab.path)
            } else {
                throw Error('Tab: ' + tab.id + ' does not have a supplied path prop')
            }
        }
        setCurrent(tab.id)
    }

    const onTabSelect = (tab) => {
        selectTab(tab)
    }

    const context: ITabContext = {
        withRoute: props.withRoute,
        current: state.current,
        setCurrent: setCurrent,
        registerTab: registerTab,
        getTabPath: getTabPath,
        getTab: getTab,
        onTabSelect: onTabSelect,
        colors: props.colors || null,
    }

    return <TabContext.Provider value={context}>{props.children}</TabContext.Provider>
}

export default TabProvider
